
import slide1 from '../sliders/Slide1.png';
import slide2 from '../sliders/Slide2.png';
import slide3 from '../sliders/Slide2.png';
import bg1 from '../sliders/bg1.png';
 

export const slide1_1 = slide1;
export const slide1_2 = slide2
export const slide1_3 = slide3;
export const bg1_1 = bg1;
 
 
 
 

